module.exports = __webpack_public_path__ + "img/dark-mode-icon-active.3bf7b23a.svg";